module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-68.b06ec176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-68.jpg
// module id = 4027
// module chunks = 13